import script from "./AdminOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrders.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrders.vue?vue&type=style&index=0&id=2bbaa4a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbaa4a3"]])

export default __exports__